import React from 'react';
import { Layout, Row, Col, Card, Tag, Button, Divider, Form, Input } from 'antd';
import AppleNavBar from '../components/AppleNavBar';
import AppleHero from '../components/AppleHero';
import ProcessFlow from '../components/ProcessFlow';
import DataCharts from '../components/DataCharts';
import CaseStudies from '../components/CaseStudies';
import AirpakAdvantages from '../components/AirpakAdvantages';
import PriceCalculator from '../components/PriceCalculator';
import ServiceIntroduction from '../components/ServiceIntroduction';
import ShippingRequirements from '../components/ShippingRequirements';
import RouteMap from '../components/RouteMap';
import FlightInfoAndMap from '../components/FlightInfoAndMap';
import USCustomsAirports from '../components/USCustomsAirports';
import SmallParcelService from '../components/SmallParcelService';
import SpecialCargoRequirements from '../components/SpecialCargoRequirements';
import AntiDumpingWarning from '../components/AntiDumpingWarning';
import ProfessionalFAQ from '../components/ProfessionalFAQ';
import CompanyStrength from '../components/CompanyStrength';
import PremiumServices from '../components/PremiumServices';
import BlogSection from '../components/BlogSection';
import '../styles/AppleStyle.css';

const { Content, Footer } = Layout;

const Home: React.FC = () => {
  // 表单处理
  const [form] = Form.useForm();

  const onFinish = () => {
    console.log('Form submitted');
    form.resetFields();
  };

  // 样式定义
  const sectionTitleStyle: React.CSSProperties = {
    fontSize: 28,
    fontWeight: 600,
    color: '#1d1d1f',
    marginBottom: 12,
    fontFamily: "'Inter Tight', Inter, sans-serif",
  };

  const sectionSubStyle: React.CSSProperties = {
    color: '#6e6e73',
    marginBottom: 24,
  };

  return (
    <Layout style={{ background: '#FFFFFF' }}>
      <AppleNavBar />
      <Content>
        <main id="main-content">
        <AppleHero />

        <ServiceIntroduction />

        {/* 专业增值服务 - 对标国际顶级公司 */}
        <PremiumServices />

        <section id="process" className="section-compact">
          <div className="container-wide">
            <div style={{ textAlign: 'center', marginBottom: 'var(--space-4xl)' }}>
              <h2 className="display-small" style={{ marginBottom: 'var(--space-md)' }}>服务流程</h2>
              <p className="body-large">从货物备货到美国本地派送，透明标准化的操作节点，确保可控时效与合规清关。</p>
            </div>
            <ProcessFlow />
            
            <Divider style={{ margin: '48px 0' }} />
            
            <Row gutter={[24, 24]} style={{ marginTop: '48px' }}>
              <Col xs={24} md={12}>
                <Card 
                  title="操作要点" 
                  bordered={false}
                  style={{ boxShadow: 'var(--shadow-md)', border: '1px solid #d2d2d7' }}
                >
                  <ul style={{ paddingLeft: '20px' }}>
                    <li style={{ marginBottom: '8px' }}>
                      <strong>如实申报：</strong>品名、材质、用途、数量、申报价值需匹配实物。
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                      <strong>包装规范：</strong>符合国际空运标准，避免内件晃动与外箱破损。
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                      <strong>合规范围：</strong>普货、带电产品按要求提供MSDS等资料。
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                      <strong>标签条码：</strong>按需提供FBA/一票多件贴标方案。
                    </li>
                  </ul>
                </Card>
              </Col>
              <Col xs={24} md={12}>
                <Card 
                  title="服务承诺" 
                  bordered={false}
                  style={{ boxShadow: 'var(--shadow-md)', border: '1px solid #d2d2d7' }}
                >
                  <div>
                    <Tag color="green" style={{ marginBottom: '8px' }}>时效保障</Tag>
                    <p style={{ margin: '8px 0', fontSize: '13px' }}>超时效免费重发或全额退款</p>
                    
                    <Tag color="blue" style={{ marginBottom: '8px' }}>安全保障</Tag>
                    <p style={{ margin: '8px 0', fontSize: '13px' }}>全程保险，货损货差100%赔付</p>
                    
                    <Tag color="orange" style={{ marginBottom: '8px' }}>服务保障</Tag>
                    <p style={{ margin: '8px 0', fontSize: '13px' }}>7x24客服响应，问题1小时内处理</p>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </section>

        <RouteMap />

        <FlightInfoAndMap />

        <section id="customs-airports" className="section" style={{ background: 'var(--background-tertiary)' }}>
          <div className="container-wide">
            <USCustomsAirports />
          </div>
        </section>

        {/* 企业实力展示 - 基于同行最佳实践 */}
        <CompanyStrength />

        <AirpakAdvantages />

        <PriceCalculator />

        <SmallParcelService />

        <SpecialCargoRequirements />

        <AntiDumpingWarning />

        <ShippingRequirements />

        <section id="data" className="section" style={{ background: 'var(--background-secondary)' }}>
          <div className="container-wide">
            <div style={{ textAlign: 'center', marginBottom: 'var(--space-4xl)' }}>
              <h2 className="display-small" style={{ marginBottom: 'var(--space-md)' }}>数据洞察</h2>
              <p className="body-large">用数据说话，展示我们的专业实力和服务质量</p>
            </div>
            <DataCharts />
          </div>
        </section>
        
        <section id="cases" className="section">
          <div className="container-wide">
            <CaseStudies />
          </div>
        </section>

        {/* 行业资讯 - 专业博客文章 */}
        <BlogSection />

        {/* 专业问答中心 - 基于同行最佳实践 */}
        <ProfessionalFAQ />

        <section id="contact" className="section anchor-offset" style={{ background: 'var(--background-secondary)' }}>
          <div className="container">
            <h2 style={sectionTitleStyle}>联系我们</h2>
            <p style={sectionSubStyle}>留下联系方式与货物信息，我们将在 1 个工作日内回复报价与时效方案。</p>
            <Row gutter={[24, 24]}>
              <Col xs={24} md={14}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                  <Row gutter={12}>
                    <Col xs={24} md={12}>
                      <Form.Item name="name" label="联系人" rules={[{ required: true, message: '请输入联系人' }]}>
                        <Input placeholder="您的姓名" size="large" autoComplete="name" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item name="phone" label="联系电话" rules={[{ required: true, message: '请输入电话' }]}>
                        <Input placeholder="手机或座机" size="large" type="tel" autoComplete="tel" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item name="cargo" label="货物信息" rules={[{ required: true, message: '请输入货物信息' }]}>
                    <Input.TextArea placeholder="品名/件数/重量/体积/是否带电等" rows={4} />
                  </Form.Item>
                  <Button type="primary" htmlType="submit" size="large">提交咨询</Button>
                </Form>
              </Col>
              <Col xs={24} md={10}>
                <Card bordered={false} style={{ border: '1px solid #d2d2d7', boxShadow: 'var(--shadow-sm)' }}>
                  <p><b>服务覆盖：</b> 全美 50 州（商业/住宅）</p>
                  <p><b>派送渠道：</b> UPS、USPS、FedEx</p>
                  <p><b>客服支持：</b> 工作日 9:00-18:00</p>
                </Card>
              </Col>
            </Row>
          </div>
        </section>
        </main>
      </Content>
      <Footer
        role="contentinfo"
        style={{
          textAlign: 'center',
          padding: '32px 16px',
          borderTop: '1px solid #d2d2d7',
          background: '#fafafc',
          color: '#6e6e73',
          fontSize: 14,
        }}
      >
        US Air Line © {new Date().getFullYear()} 美国空派专线
      </Footer>
    </Layout>
  );
};

export default Home;


